import { User } from '@allara-health/source-health-client'
import ProfileImage from 'components/SourceProfileImage/ProfileImage'
import { ReactComponent as ExternalLinkIcon } from 'assets/images/external-link.svg'
import { useCallback } from 'react'
import { Text, HStack, VStack, Box } from '@chakra-ui/react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { ProviderTags } from 'containers/Scheduling/types'

interface ProviderDetailsProps {
  provider: User
  className?: string
  externalLink?: string
  providerTags?: ProviderTags | null
}

const ProviderDetails: React.FC<ProviderDetailsProps> = ({
  provider,
  className,
  externalLink,
  providerTags = null,
}) => {
  const openExternalLink = useCallback(() => {
    window.open(externalLink, '_blank')
  }, [externalLink])

  const { patientProviderMatchingEnabled } = useFlags()

  const showProviderTags =
    patientProviderMatchingEnabled &&
    providerTags &&
    providerTags.tags.length > 0

  return (
    <HStack
      className={`provider ${className}`}
      align={showProviderTags ? 'flex-start' : 'center'}
      spacing={2}
    >
      <ProfileImage user={provider} className="provider-image" />
      <VStack align="flex-start" spacing={0}>
        <HStack spacing={2}>
          <Text as="h6" mb={0}>
            {provider.first_name} {provider.last_name}
            {provider.display_title ? `, ${provider.display_title}` : ''}
          </Text>
          {externalLink !== undefined && (
            <ExternalLinkIcon
              className="cursor-pointer"
              onClick={openExternalLink}
            />
          )}
        </HStack>
        {showProviderTags ? (
          <Box mt="10px">
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '4px',
                alignItems: 'flex-start',
              }}
            >
              {providerTags?.tags.map((tag) => (
                <span
                  key={tag.id}
                  style={{
                    backgroundColor: '#E1EC80CC',
                    color: '#54524F',
                    fontSize: '10px',
                    fontWeight: '600',
                    padding: '3px 8px',
                    borderRadius: '25px',
                    textTransform: 'uppercase',
                    display: 'inline-block',
                    wordBreak: 'break-word',
                    maxWidth: '200px', // Roughly 25 characters at 10px font size
                    flexShrink: 0,
                    width: 'fit-content',
                  }}
                >
                  {tag.text.toUpperCase()}
                </span>
              ))}
            </div>
          </Box>
        ) : null}
      </VStack>
    </HStack>
  )
}

export default ProviderDetails
